import { MuiThemeProvider } from "material-ui-old/styles";
import { Col, Grid, Row } from "react-bootstrap";
import React, { PureComponent } from "react";
import * as wevoConfigurationTypes from "../../modules/configure-wevo/types";
import * as wevoConfigurationActions from "../../modules/configure-wevo/actions";
import * as wevoActions from "../../modules/wevos/actions";
import UploadCard from "./UploadCard";
import { GridList, GridTile } from "material-ui-old/GridList";
import { isNil } from "lodash";
import Button from "../Button";
import PreLoader from "@wevo/react-components/lib/PreLoader";
import ImageCard from "./ImageCard";
import { trackerActions } from "../../modules/tracker";
import { connect } from "react-redux";
import { ConfigureProjectEvents } from "../../modules/tracker/event-names";

class SelectPages extends PureComponent {
    static MAX_PAGES = 6;
    static MIN_DROPAREA_HEIGHT = 320;
    static COLUMNS = 3;
    static GRID_PADDING = 5;

    constructor(props) {
        super(props);

        this.state = SelectPages.getStateFromProps(props);

        /*
          Set props dispatch functions to class functions and bind
         */
        this.removePageError = this.props.removePageError.bind(this);

        /*
          Bind functions that will be used as either handlers
          or be passed down to
         */
        this.setProperties = this.setProperties.bind(this);
        this.createPage = this.createPage.bind(this);
    }

    componentWillMount() {
        this.props.trackEvent(
            ConfigureProjectEvents.DID_NAVIGATE_TO_PAGE_SELECTION
        );
    }

    componentWillUnmount() {
        this.props.removeAllPageErrors();
    }

    componentWillReceiveProps(nextProps) {
        this.setState(SelectPages.getStateFromProps(nextProps));
    }

    static getStateFromProps(props) {
        const { wevo } = props;
        const baseline = wevo.pages.find(page => {
            return page.isActive && page.isBaseline;
        });
        return {
            baseline: baseline ? baseline.id : null
        };
    }

    setProperties(pageId, properties) {
        if (!isNil(properties.isBaseline) && properties.isBaseline) {
            return this.newBaseline(pageId, properties);
        }
        this.save(pageId, properties);
    }

    removePage(pageId) {
        const { wevoId } = this.props;
        this.props
            .removePage(wevoId, pageId)
            .then(() => {
                if (this.state.baseline === pageId) {
                    this.setState({
                        baseline: null
                    });
                }
            })
            .then(() => {
                this.props.fetchWevo(wevoId);
            })
            .catch(err => console.error(err));
    }

    createPage(imageFile, sortOrder) {
        const { wevo } = this.props;
        const { devices } = wevo;
        const device = devices[0];
        this.props
            .createPage(wevo.id, device.id, imageFile, sortOrder)
            .then(() => {
                return this.props.fetchWevo(wevo.id);
            })
            .catch(e => console.error(e));
    }

    newBaseline(pageId, properties) {
        const { wevoId } = this.props;
        if (this.state.baseline) {
            this.props
                .updatePage(wevoId, this.state.baseline, { isBaseline: false })
                .then(() => {
                    this.save(pageId, properties);
                })
                .catch(err => {
                    console.error(err);
                });
        } else {
            this.save(pageId, properties);
        }
    }

    save(pageId, pageUpdates) {
        const { wevoId } = this.props;
        this.props
            .updatePage(wevoId, pageId, pageUpdates)
            .then(() => {
                if (!isNil(pageUpdates.isBaseline)) {
                    if (pageUpdates.isBaseline) {
                        this.setState({
                            baseline: pageId
                        });
                    } else {
                        if (this.state.baseline === pageId) {
                            this.setState({
                                baseline: null
                            });
                        }
                    }
                }
            })
            .catch(err => {
                console.error(err);
                throw err;
            });
    }

    isValid() {
        const { wevo } = this.props;
        return (
            wevo.pages.reduce((count, page) => {
                if (page.isActive) {
                    count++;
                }
                return count;
            }, 0) >= 1
        );
    }

    renderButton() {
        const { nextStepText, wevoId } = this.props;
        const style = { width: "240px" };
        if (!this.isValid()) {
            return (
                <Button disabled={true} color="disabled" style={style}>
                    {" "}
                    {nextStepText}
                </Button>
            );
        }
        return (
            <Button onClick={() => this.props.toNextStep(wevoId)} style={style}>
                {nextStepText}
            </Button>
        );
    }

    renderGrid() {
        const { wevo, loadingState, isReadOnly } = this.props;
        let activeUploads = [];
        if (loadingState && loadingState.activeUploads) {
            activeUploads = Object.keys(loadingState.activeUploads).reduce(
                (acc, sortOrder) => {
                    const activeUpload = loadingState.activeUploads[sortOrder];
                    switch (activeUpload.status) {
                        case wevoConfigurationTypes.REQUEST_CREATE_PAGE:
                            acc.push({
                                name: activeUpload.name,
                                sortOrder,
                                loading: true
                            });
                            break;
                        case wevoConfigurationTypes.CREATE_PAGE_ERROR:
                            acc.push({
                                name: activeUpload.name,
                                sortOrder: sortOrder,
                                errorState: true,
                                error: activeUpload.error
                            });
                            break;
                        default:
                            break;
                    }
                    return acc;
                },
                []
            );
        }

        const activePages = wevo.pages.filter(page => page.isActive);

        const sortedPages = [...activePages, ...activeUploads].sort((a, b) => {
            const sortOrderDiff = a.sortOrder - b.sortOrder;
            if (sortOrderDiff !== 0) {
                return sortOrderDiff;
            }
            return a.name > b.name ? 1 : -1;
        });
        const sortOrderStart =
            (sortedPages.length > 0
                ? sortedPages.reduce((currMax, p) => {
                      const sortOrder = parseInt(p.sortOrder, 10);
                      if (sortOrder > currMax) {
                          currMax = sortOrder;
                      }
                      return currMax;
                  }, 1)
                : 0) + 1;
        const gridStyle = {
            padding: "0% 7.5%"
        };

        /*
          This is super annoying to have to do it this way (to repeat the GridList
          based on sortedPages length), but unfortunately GridList yells when you have
          any non-GridTile child or string. So when you do something like
          <condition> && <UploadCard> or <condition>? <UploadCard> : "" to make sure the upload
          card doesn't show when the maximum pages have been reached, GridList yells.

          MaterialUI is a stupid library
         */
        if (sortedPages.length >= SelectPages.MAX_PAGES || isReadOnly) {
            return (
                <GridList
                    cols={SelectPages.COLUMNS}
                    padding={SelectPages.GRID_PADDING}
                    cellHeight={SelectPages.MIN_DROPAREA_HEIGHT}
                    style={gridStyle}
                >
                    {sortedPages.map((page, index) => (
                        <GridTile
                            key={
                                page.id
                                    ? `page-by-id-${page.id}`
                                    : `page-by-sort-order-${page.sortOrder}`
                            }
                        >
                            <ImageCard
                                pageId={page.id ? page.id : null}
                                wevoId={wevo.id}
                                removePage={
                                    page.id
                                        ? this.removePage.bind(this, page.id)
                                        : this.removePageError.bind(
                                              this,
                                              page.sortOrder
                                          )
                                }
                                page={page}
                                setProperties={this.setProperties}
                                loadingState={
                                    loadingState
                                        ? page.id
                                            ? loadingState[page.id]
                                            : loadingState.activeUploads
                                                ? loadingState.activeUploads[
                                                      page.sortOrder
                                                  ]
                                                : null
                                        : null
                                }
                                errorState={page.errorState}
                                error={page.error}
                                isReadOnly={isReadOnly}
                            />
                        </GridTile>
                    ))}
                </GridList>
            );
        }
        return (
            <GridList
                cols={SelectPages.COLUMNS}
                padding={SelectPages.GRID_PADDING}
                cellHeight={SelectPages.MIN_DROPAREA_HEIGHT}
                style={gridStyle}
            >
                {sortedPages.map((page, index) => (
                    <GridTile
                        key={
                            page.id
                                ? `page-by-id-${page.id}`
                                : `page-by-sort-order-${page.sortOrder}`
                        }
                    >
                        <ImageCard
                            pageId={page.id ? page.id : null}
                            wevoId={wevo.id}
                            removePage={
                                page.id
                                    ? this.removePage.bind(this, page.id)
                                    : this.removePageError.bind(
                                          this,
                                          page.sortOrder
                                      )
                            }
                            page={page}
                            setProperties={this.setProperties}
                            loadingState={
                                loadingState
                                    ? page.id
                                        ? loadingState[page.id]
                                        : loadingState.activeUploads
                                            ? loadingState.activeUploads[
                                                  page.sortOrder
                                              ]
                                            : null
                                    : null
                            }
                            errorState={page.errorState}
                            error={page.error}
                        />
                    </GridTile>
                ))}
                <GridTile
                    cols={sortedPages.length === 0 ? SelectPages.COLUMNS : 1}
                    style={{ overflow: "visible" }}
                >
                    <UploadCard
                        createPage={this.createPage}
                        sortOrderStart={sortOrderStart}
                        remainingPages={
                            SelectPages.MAX_PAGES - sortedPages.length
                        }
                        isFull={sortedPages.length === 0}
                    />
                </GridTile>
            </GridList>
        );
    }

    render() {
        const { wevo } = this.props;
        if (!wevo || !wevo.pages) {
            return <PreLoader />;
        }

        const labels = this.props.stepLabels;

        return (
            <Grid style={{ width: "100%" }}>
                <Row>
                    <Col xs={6} xsOffset={3}>
                        <h1>{labels.title || labels.leftBar}</h1>
                        <h5>{labels.subtitle || ""}</h5>
                    </Col>
                </Row>
                <MuiThemeProvider>
                    <Row
                        style={{
                            marginTop: "30px",
                            marginLeft: "0px",
                            marginRight: "0px"
                        }}
                    >
                        <Row>{this.renderGrid()}</Row>
                        <Row
                            style={{
                                marginTop: "30px",
                                marginLeft: "0px",
                                marginRight: "0px"
                            }}
                        >
                            <Col xs={4} xsOffset={4}>
                                {this.renderButton()}
                            </Col>
                        </Row>
                    </Row>
                </MuiThemeProvider>
            </Grid>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchWevo: wevoId => dispatch(wevoActions.fetchWevo(wevoId)),
        trackEvent: (eventName, eventProperties) =>
            dispatch(trackerActions.trackEvent(eventName, eventProperties)),
        createPage: (wevoId, deviceId, imageFile, sortOrder) =>
            dispatch(
                wevoConfigurationActions.createPageFromImage(
                    imageFile,
                    wevoId,
                    deviceId,
                    sortOrder
                )
            ),
        updatePage: (wevoId, pageId, updateProperties) =>
            dispatch(
                wevoConfigurationActions.updatePage(
                    wevoId,
                    pageId,
                    updateProperties
                )
            ),
        removeAllPageErrors: () =>
            dispatch(wevoConfigurationActions.clearAllErrorsFromSelectPages()),
        removePageError: sortOrder =>
            dispatch(
                wevoConfigurationActions.clearErrorFromSelectPages(sortOrder)
            ),
        removePage: (wevoId, pageId) =>
            dispatch(
                wevoConfigurationActions.removePageFromWevo(wevoId, pageId)
            )
    };
};

export default connect(
    null,
    mapDispatchToProps
)(SelectPages);



// WEBPACK FOOTER //
// ./src/components/CreateTest/SelectPages.js